import React from "react";

export default function ClosedCard() {
  return (
    <div className="line-card--closed">
      <div className="line-closed-icon" aria-hidden><i class='fas fa-stop-circle fa-fw'></i></div>
      <h2 className="line-title--closed">受付番号予約</h2>
      <h2 className="line-title2--closed">
        <span className="accent">オンライン受付</span>
        <span className="accent-orange">時間外</span>
      </h2>
      <div className="line-description--closed">
        <p className="line-desc--closed">
          オンライン受付の時間は 9:30–11:00 / 17:00–18:30 です。受付開始後30分と受付終了前30分はオンライン受付できません。
        </p>
      </div>
   
    </div>
  );
}